import {
  getAXRouteAuthorityRegistry,
} from './AXRouteAuthorityRegistry';

import {
  getAXNavigationAuthority,
} from './AXNavigationAuthorityEngine';

import {
  getAXPageIdentities,
} from './AXPageSeparationEngine';

export interface AXRuntimeVerificationResult {
  readonly passed: boolean;
  readonly routesVerified: number;
  readonly navigationRulesVerified: number;
  readonly pageIdentitiesVerified: number;
  readonly verifiedAt: string;
}

export function verifyAXRuntime():
AXRuntimeVerificationResult {

  const routes = getAXRouteAuthorityRegistry();
  const navigation = getAXNavigationAuthority();
  const pages = getAXPageIdentities();

  const passed =
    routes.length > 0 &&
    navigation.length > 0 &&
    pages.length > 0;

  return Object.freeze({
    passed,
    routesVerified: routes.length,
    navigationRulesVerified: navigation.length,
    pageIdentitiesVerified: pages.length,
    verifiedAt: new Date().toISOString(),
  });
}
